import React from "react";
import "./OrderDetailsPopup.css";
import moment from "moment";

const OrderDetailsPopup = ({
  isVisible,
  onClose,
  order,
  handleBookDaas,
  handleCancelDaas,
  handlePrint,
}) => {
  if (!isVisible) return null;

  const orderStatus =
    order.status.toUpperCase() === "READY TO PICK" ||
    order.status.toUpperCase() === "ACCEPTED"
      ? order.deliveryDetails !== "N/A"
        ? "OUT FOR DELIVERY"
        : "ACCEPTED"
      : order.status;

  const [startTime, endTime] = order.deliverBy
    .split(" - ")
    .map((time) => time.trim().split(" ")[0] + " " + time.split(" ")[1]);

  const startMoment = moment(startTime, "hh:mm A");
  const endMoment = moment(endTime, "hh:mm A");

  const difference = endMoment.diff(startMoment, "minutes");
  const formattedDate = moment(order.deliveryDate).format("dddd, Do MMM");

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <div className="popup-header-details">
            <h5 className="popup-bold">Order ID: {order.orderID}</h5>
            <h5 className="popup-bold">
              Name: {order.craverDetails.craverName}
            </h5>
          </div>
          <h5 className="popup-time">
            {order.orderTimeStamp.substring(11, 16)}
          </h5>
        </div>
        <div className="popup-body">
          {order.orderedItems.map((item, index) => (
            <p key={index} className="popup-item">
              <strong>
                {item.quantity} - {item.menuName}
              </strong>
            </p>
          ))}
          {difference == 60 ? (
            <div>
              <p className="mt-1 mb-0">Deliver By:</p>
              <p className="mt-0 mb-0">
                <strong>
                  {order.deliverBy} - {formattedDate}
                </strong>
              </p>
            </div>
          ) : null}
          <div className="popup-details mt-5">
            {order.deliveryDetails !== "N/A" ? (
              <div className="driver-info">
                <p>
                  <strong>
                    Driver Name: {order.deliveryDetails.deliveryAgentName}
                  </strong>
                </p>
                <p>
                  <strong>
                    Driver Mobile: {order.deliveryDetails.deliveryAgentMobile}
                  </strong>
                </p>
              </div>
            ) : null}
            <a
              href={`http://maps.google.com/?q=${order.craverDetails.craverAddressCoordinates.lat},${order.craverDetails.craverAddressCoordinates.lng}`}
              rel="noreferrer"
              target="_blank"
            >
              <i className="fa fa-map-marker"></i>{" "}
              {order.craverDetails.craverAddress}
            </a>
            <p>
              <strong>Distance: {order.distance}</strong>
            </p>
            <div className="popup-details-footer">
              <div>
                <p>Phone number:</p>
                <p>
                  <strong>{order.craverDetails.craverMobile}</strong>
                </p>
              </div>
              <button
                type="button"
                class="btn btn-info"
                onClick={() => {
                  handlePrint();
                }}
              >
                Print
              </button>
              <button className="btn-status">{orderStatus}</button>
              {order.status.toUpperCase() !== "DELIVERED" ? (
                <>
                  {order.deliveryStatus.toUpperCase() === "N/A" ||
                  order.deliveryStatus.toUpperCase() === "NOT ASSIGNED" ||
                  order.deliveryStatus.toUpperCase() === "CANCELLED" ||
                  order.deliveryStatus.toUpperCase() === "FAILED" ||
                  order.deliveryStatus.toUpperCase() ===
                    "CANCELLED DAAS BY ADMIN" ? (
                    <button
                      type="button"
                      class="btn btn-warning"
                      onClick={() => {
                        handleBookDaas();
                      }}
                    >
                      Book Daas
                    </button>
                  ) : order.deliveryStatus.toUpperCase() !== "ASSIGNED" ? (
                    <button
                      type="button"
                      class="btn btn-warning"
                      onClick={() => {
                        handleCancelDaas();
                      }}
                    >
                      Cancel Daas
                    </button>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPopup;
